'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('./../../utils/formatting');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bucket = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/';

var leftAlign = {
  textAlign: 'left'
};

var fromNow = function fromNow(date) {
  return (0, _moment2.default)(date).fromNow();
};
var smallFont = {
  fontSize: '60%'
};

var dyzioGreen = {
  color: '#20c49e'
};

var PopupContent = function PopupContent(_ref) {
  var supportingData = _ref.supportingData;
  var reach = supportingData.reach,
      impressions = supportingData.impressions,
      createdBy = supportingData.createdBy,
      createdDate = supportingData.createdDate,
      actions = supportingData.actions,
      engagements = supportingData.engagements,
      clicks = supportingData.clicks;

  var imageSrc = '' + bucket + supportingData.filePath;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_semanticUiReact.Image, { src: imageSrc, bordered: true, width: 600 }),
    _react2.default.createElement(
      'table',
      { style: { width: '100%', marginTop: '5px', border: '1px solid #ccc', padding: '3px', backgroundColor: '#eee' } },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            { style: leftAlign },
            'reach'
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _formatting.sciFormatted)(reach)
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            { style: leftAlign },
            'impressions'
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _formatting.sciFormatted)(impressions)
          )
        ),
        clicks && _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            { style: leftAlign },
            'clicks'
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _formatting.sciFormatted)(clicks)
          )
        ),
        engagements && _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            { style: leftAlign },
            'engagements'
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _formatting.sciFormatted)(engagements)
          )
        ),
        actions && _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            { style: leftAlign },
            'actions'
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _formatting.sciFormatted)(actions)
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { colSpan: 2, style: { fontSize: '80%', borderTop: '1px solid #ccc', textAlign: 'center' } },
            'data added manually by ',
            createdBy,
            _react2.default.createElement('br', null),
            fromNow(createdDate)
          )
        )
      )
    )
  );
};

var SourceComponent = function SourceComponent(_ref2) {
  var post = _ref2.post,
      voxi = _ref2.voxi;
  var insights = post.latestStatistic.insights;
  var _post$trackedAsset = post.trackedAsset,
      platform = _post$trackedAsset.platform,
      supportingData = _post$trackedAsset.supportingData;


  var latestSupportingData = void 0;

  if (supportingData && supportingData.length) {
    console.log(supportingData);
    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
      return o.createdDate;
    }));
    latestSupportingData = ordered[0];
  }

  if (insights) {
    return _react2.default.createElement(_semanticUiReact.Popup, {
      hoverable: true,
      trigger: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: dyzioGreen },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock alternate' }),
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed' })
        ),
        _react2.default.createElement(
          'div',
          { style: smallFont },
          fromNow(post.latestStatistic.createdDate)
        )
      ),
      content: 'Authorised data collected from the ' + _lodash2.default.capitalize(platform) + ' API ' + fromNow(post.latestStatistic.createdDate)
    });
  }

  if (voxi) {
    return _react2.default.createElement(_semanticUiReact.Popup, {
      hoverable: true,
      trigger: _react2.default.createElement(
        'div',
        { style: dyzioGreen },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'file image outline', color: 'pink', size: 'large' })
      ),
      content: _react2.default.createElement(PopupContent, {
        supportingData: latestSupportingData
      })
    });
  }

  if (latestSupportingData) {
    return _react2.default.createElement(_semanticUiReact.Popup, {
      hoverable: true,
      size: 'huge',
      trigger: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: dyzioGreen },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'cloud upload' })
        ),
        _react2.default.createElement(
          'div',
          { style: smallFont },
          fromNow(latestSupportingData.createdDate)
        )
      ),
      content: _react2.default.createElement(PopupContent, {
        supportingData: latestSupportingData
      })
    });
  }

  return _react2.default.createElement(_semanticUiReact.Popup, {
    trigger: _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'world', color: 'grey' }),
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed', color: 'grey' })
      ),
      _react2.default.createElement(
        'div',
        { style: smallFont },
        fromNow(post.latestStatistic.createdDate)
      )
    ),
    content: 'Public data collected from the ' + _lodash2.default.capitalize(platform) + ' API ' + fromNow(post.latestStatistic.createdDate)
  });
};

exports.default = SourceComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/source-component/index.js
 ** module id = 2600
 ** module chunks = 0
 **/